import React, { createContext, useState, useContext } from 'react';

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState('en'); // Default language
  const supportedLanguages = ['en', 'es', 'pt']; // English, Spanish, Portuguese

  const changeLanguage = (lng) => {
    if (supportedLanguages.includes(lng)) {
      setLanguage(lng);
    } else {
      console.warn(`Unsupported language: ${lng}`);
    }
  };

  return (
    <LanguageContext.Provider value={{ 
      language, 
      changeLanguage,
      supportedLanguages 
    }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => useContext(LanguageContext);
